import axios from 'axios';
import { isNewSystem } from '../../switch';

export const setCurrentQRCodeTicket = ticket => ({ type: 'SET_CURRENT_QRCODE_FORM_TICKET', payload: ticket });

export const getQRCodeDocuments = (deviceId, anonymousConnexion = false) => {
  const headers = anonymousConnexion
    ? {
      'x-service-key': QRCODE_ISSUE_REPORT_API_KEY,
    }
    : {};
  return {
    type: 'GET_QRCODE_DOCUMENTS',
    payload: axios.get(`/devices/${deviceId}/documents/`, { headers }).then(res => res.data)
  };
};

export const getQRCodeDocumentContent = (deviceId, documentId, anonymousConnexion = false) => {
  const headers = anonymousConnexion
    ? {
      'x-service-key': QRCODE_ISSUE_REPORT_API_KEY,
    }
    : {};
  return {
    type: 'GET_QRCODE_DOCUMENT_CONTENT',
    payload: axios.get(
      `/devices/${deviceId}/documents/${documentId}/content?variant=original`,
      { headers, responseType: 'blob' }
    ).then(res => res.data)
  };
};

export const scanQrCode = hardwareId => { // Calls /payload endpoint everytime a Qr Code is scanned
  console.log('scanQrCode', hardwareId);
  if (isNewSystem()) {
    const payload = { hardwareId, time: new Date() };
    const urlSuffix = window.location.hostname.split('.').pop();
    axios.post(`https://iot.merciyanis.${urlSuffix}/payload/qrcode`, payload).then(res => res.data).catch(err => console.error(err));
  }
};